// Help.jsx
import React from "react";
import { ArrowLeft, HelpCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Help = () => {
  const navigate = useNavigate();

  const statuses = [
    {
      name: "Belum bayar",
      color: "bg-yellow-100 text-yellow-800",
      description:
        "Pesanan sudah dibuat, tapi pembayaran belum diterima. Silakan lakukan pembayaran melalui transfer bank, WA, atau QRIS sesuai instruksi penjual/admin.",
    },
    {
      name: "Sudah bayar",
      color: "bg-green-100 text-green-800",
      description:
        "Pembayaran sudah dikonfirmasi oleh admin/penjual. Pesanan akan segera diproses.",
    },
    {
      name: "Processing",
      color: "bg-blue-100 text-blue-800",
      description:
        "Pesanan sedang diproses oleh penjual (packing, persiapan pengiriman, dll).",
    },
    {
      name: "Dikirim",
      color: "bg-purple-100 text-purple-800",
      description:
        "Barang sudah dikirim oleh penjual. Anda akan menerima nomor resi pengiriman (jika ada).",
    },
    {
      name: "Diterima",
      color: "bg-emerald-100 text-emerald-800",
      description:
        "Barang sudah sampai di tangan Anda (status ini biasanya di-update manual oleh pembeli atau penjual).",
    },
    {
      name: "Selesai",
      color: "bg-gray-100 text-gray-800",
      description:
        "Transaksi selesai sepenuhnya. Pesanan sudah diterima dan tidak ada keluhan lagi.",
    },
    {
      name: "Batal",
      color: "bg-red-100 text-red-800",
      description:
        "Pesanan dibatalkan (oleh pembeli, penjual, atau admin). Biasanya karena pembayaran tidak dilakukan, stok habis, atau alasan lain.",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        {/* Header */}
        <div className="flex items-center justify-between mb-8">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center text-blue-600 hover:text-blue-800"
          >
            <ArrowLeft size={20} className="mr-2" />
            Kembali
          </button>
          <h1 className="text-2xl font-bold text-gray-900 flex items-center">
            <HelpCircle size={28} className="mr-3 text-blue-600" />
            Bantuan & Cara Pemesanan
          </h1>
        </div>

        {/* Intro */}
        <div className="bg-white p-6 rounded-xl shadow-sm mb-8">
          <h2 className="text-xl font-semibold mb-4">Cara Memesan Barang di Toko Kamulyaan</h2>
          <ol className="list-decimal pl-5 space-y-3 text-gray-700">
            <li>Buka halaman produk yang Anda inginkan.</li>
            <li>Klik tombol <strong>"Beli Sekarang"</strong>.</li>
            <li>Isi detail pesanan (jumlah, alamat pengiriman, dll).</li>
            <li>Pilih metode pembayaran (transfer, QRIS, atau WA).</li>
            <li>Lakukan pembayaran sesuai instruksi.</li>
            <li>Setelah pembayaran berhasil, status akan berubah menjadi <strong>"Sudah bayar"</strong>.</li>
            <li>Ikuti status pesanan di <strong>Panel Pembelian</strong> Anda.</li>
          </ol>
          <p className="mt-4 text-sm text-gray-600">
            Jika ada kendala, hubungi penjual langsung melalui nomor telepon atau WhatsApp yang tertera di halaman produk.
          </p>
        </div>

        {/* Status Explanation */}
        <div className="bg-white p-6 rounded-xl shadow-sm">
          <h2 className="text-xl font-semibold mb-6">7 Status Pemesanan Barang</h2>
          <div className="space-y-4">
            {statuses.map((status) => (
              <div
                key={status.name}
                className={`p-5 rounded-lg border ${status.color} flex items-start gap-4`}
              >
                <div className="flex-1">
                  <h3 className="font-bold text-base">{status.name}</h3>
                  <p className="mt-1 text-sm">{status.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Footer note */}
        <div className="text-center mt-10 text-sm text-gray-500">
          <p>Terima kasih telah berbelanja di Toko Kamulyaan!</p>
          <p className="mt-1">Masih bingung? Hubungi admin melalui WhatsApp atau email.</p>
        </div>
      </div>
    </div>
  );
};

export default Help;